import type { NamePath } from './Form';

export type combineType = string | number;

export const combineFormNamePath = (...arguments_: NamePath[]): combineType[] => {
  return arguments_.reduce((prev: combineType[], current) => {
    if (Array.isArray(current)) {
      return [...prev, ...current];
    }
    return [...prev, current];
  }, [] as combineType[]);
};
